<template>
  <v-navigation-drawer v-model="chat" absolute temporary right width="25%">
    <div class="chat-wrapper d-flex flex-column grey lighten-4 pa-5">
      <div class="text-h6 mb-4 text-center">Ερωτήσεις</div>

      <div class="questions-wrapper" ref="questionsWrapper">
        <div
          class="d-flex flex-column"
          v-for="(question, index) in questions"
          :key="index"
        >
          <div class="body-1 mr-2">
            {{ question.question }}
          </div>

          <v-divider class="my-2"></v-divider>
        </div>

        <div class="body-1 text-center" v-if="!questions.length">
          Δεν έχουν υποβληθεί ερωτήσεις
        </div>
      </div>

      <v-text-field
        outlined
        hide-details
        class="mt-auto flex-grow-0"
        color="primary"
        append-icon="mdi-send"
        v-model="question"
        @click:append="onSendQuestion"
        @keyup.enter="onSendQuestion"
        autocomplete="off"
        :loading="loader"
      ></v-text-field>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      question: "",
      loader: false,
    };
  },
  computed: {
    chat: {
      get() {
        return this.$store.state.base.chat;
      },
      set(value) {
        if (!value) this.toggleChat(value);
      },
    },
    ...mapState({
      questions: (state) => state.school.questions,
    }),
  },
  methods: {
    ...mapMutations(["toggleChat"]),
    ...mapActions(["sendQuestion"]),
    async onSendQuestion() {
      if (!this.question) return;

      this.loader = true;

      try {
        await this.sendQuestion(this.question);

        this.loader = false;
        this.$vuetify.goTo(this.$refs.questionsWrapper.clientHeight, {
          container: ".questions-wrapper",
        });
      } catch (e) {
        console.log(e);
        this.loader = false;
      }

      this.question = "";
    },
  },
  watch: {
    chat(newValue) {
      if (newValue) {
        this.$vuetify.goTo(this.$refs.questionsWrapper.clientHeight, {
          container: ".questions-wrapper",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-wrapper {
  height: 100%;
}

.questions-wrapper {
  flex: 1 0 auto;
  overflow-y: auto;
  height: 0px;
}
</style>